import type { IResponse } from '../interface'
import type {
  ServerSeoData,
  UploadBehaviorData,
  UserLocation,
} from '../interface/seo'
import { fetch } from '../request'
import { useTime } from '~/hooks/useTime'

const getSeoCached: () => ServerSeoData[] | undefined = () => {
  const data = localGetItem('seoData')
  if (!data) {
    return
  }
  const { value, expired } = data
  const { $dayjs } = useTime()
  if ($dayjs(expired).isBefore($dayjs())) {
    return
  }
  return value
}

export const getSeoData = async () => {
  if (import.meta.client) {
    const cached = getSeoCached()
    if (cached) {
      return cached
    }
  }

  try {
    const result = await fetch<IResponse<ServerSeoData[]>>(
      '/promotion_center/seo_config/',
      {
        method: 'GET',
      }
    )

    if (import.meta.client) {
      localSetItem('seoData', {
        value: result.data,
        expired: useTime().$dayjs().add(1, 'hour').valueOf(),
      })
    }
    return result.data
  } catch (err) {
    return []
  }
}

export const getLocation = () => {
  return $fetch<UserLocation>(
    'https://pro.ip-api.com/json/?key=CCV4i9vC7OwDJ7K'
  )
}

export const postUploadBehavior = (data: UploadBehaviorData) => {
  return fetch('/user_operation/user_behavior/', {
    method: 'POST',
    body: data,
  })
}
